"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthlyNotificationEmailSettings = exports.WeeklyNotificationEmailSettings = exports.DailyNotificationEmailSettings = exports.InstantNotificationEmailSettings = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/BlogNotificationEmails/constants");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _actions = require("settings-ui-sdk/BlogNotificationEmails/actions");

var _BlogNotificationEmail = _interopRequireDefault(require("settings-ui-sdk/BlogNotificationEmails/BlogNotificationEmail"));

var _selectors = require("settings-ui-sdk/BlogNotificationEmails/selectors");

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.ID,
  initialValue: null
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.ENABLED,
  initialValue: false
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.REPLY_TO,
  initialValue: null
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.FROM_NAME,
  initialValue: null
}];

var getStagedNotificationEmailSettings = function getStagedNotificationEmailSettings(emailType) {
  return new _StagedObject.default({
    stagedSelector: function stagedSelector(state) {
      return state.modules.website.blogs.staging.updateNotificationEmails[emailType];
    },
    domainSelector: function domainSelector(state) {
      return (0, _selectors.getNotificationEmailByTypeForBlogFromCurrentRoute)(emailType)(state);
    },
    requestSuccessActionType: _actions.FetchNotificationEmailsActionTypes.SUCCESS,
    requestSuccessDataSelector: function requestSuccessDataSelector(payload) {
      return new _BlogNotificationEmail.default(payload.data.find(function (obj) {
        return obj.blog_email_type === emailType;
      }));
    },
    namespace: _UrlPathParams.BLOGS,
    objectType: "" + emailType + _constants.BLOG_NOTIFICATION_EMAIL,
    properties: properties
  });
};

var InstantNotificationEmailSettings = getStagedNotificationEmailSettings(_constants.INSTANT_EMAIL);
exports.InstantNotificationEmailSettings = InstantNotificationEmailSettings;
var DailyNotificationEmailSettings = getStagedNotificationEmailSettings(_constants.DAILY_EMAIL);
exports.DailyNotificationEmailSettings = DailyNotificationEmailSettings;
var WeeklyNotificationEmailSettings = getStagedNotificationEmailSettings(_constants.WEEKLY_EMAIL);
exports.WeeklyNotificationEmailSettings = WeeklyNotificationEmailSettings;
var MonthlyNotificationEmailSettings = getStagedNotificationEmailSettings(_constants.MONTHLY_EMAIL);
exports.MonthlyNotificationEmailSettings = MonthlyNotificationEmailSettings;